// Load Snapchat script based on OneTrust consent
const loadSnapchatScript = () => {
  if (window.Optanon && window.OptanonActiveGroups.includes('4')) {
    let script = document.createElement('script');
    script.src = 'https://intg.snapchat.com/shopify/shopify-scevent-init.js?id=a6a697fd-9d8e-40d3-8c5a-0d18d81d8602&shop=native-deodorant.myshopify.com';
    script.type = 'text/javascript';
    script.className = 'optanon-category-4'; // For OneTrust to manage consent
    document.head.appendChild(script);

    // Optionally listen for consent changes to update the script type to 'text/javascript'
    Optanon.OnConsentChanged(() => {
      if (OptanonActiveGroups.includes('4')) {
        script.type = 'text/javascript'; // Change type to 'text/javascript' to activate script
      }
    });
  } else {
    // If OneTrust is not ready, wait and try again
    setTimeout(loadSnapchatScript, 100); // Retry after 100 milliseconds
  }
};

document.addEventListener('DOMContentLoaded', () => {
  loadSnapchatScript();
});
